import React, { useEffect, useState } from 'react';

// material-ui
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import ButtonBase from '@material-ui/core/ButtonBase';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';

//icons
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AutorenewIcon from '@material-ui/icons/Autorenew';


// app components
import { usePouchDB } from '../../../components/PouchDB/PouchDBProvider';
import { useDataSync } from '../../../components/PouchDB/DataSyncProvider';
import AppPageLoading from '../../../components/AppPageLoading';
//utils
//import uuidv1 from 'uuid/v1';
// styles
import useStyles from './styles';

// images
import kb from '../../../images/kb.png';

//utils 
import qs from 'query-string';
import { Link, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { FormControl, Select, MenuItem } from '@material-ui/core';


function Home({ history, match, location }) {

    const classes = useStyles();
    const { user: { metadata }, dataKK, dataKB, dataPK, dataBkkbn } = usePouchDB();
    const { manualSync } = useDataSync();
    const [dataBkkbnDocs, setDataBkkbnDocs] = useState([]);
    const [isFetching, setFetching] = useState(true);
    const [isDeleting, setDeleting] = useState(false);
    const [kepalaKels, setKepalaKels] = useState([])
    const [status, setStatus] = useState([])
    const { enqueueSnackbar } = useSnackbar()
    
    const [filterRwRt, setFilterRwRt] = useState('');
    const [didCancel, setDidCancel] = useState(false);

    const [statusSensus, setStatusSensus] = useState('');
    const [username, setUserName] = useState([]);
    const [name, setName] = useState('')
    const [renew, setRenew] = useState(false)
    const [dataBkkbnDocsRenew, setDataBkkbnDocsRenew] = useState([]);

    const params = useParams();

    const getAllDataBkkbn = async () => {
        
        setFetching(true)
        
        try {
            const query = await dataBkkbn.local.allDocs({
                include_docs: true,
            });

            const newDocs = [];
            const userName = [];
            let name = ''
            let start = true
            query.rows.forEach(items => {
                
                if (items.doc.user_name) {

                    newDocs.push(items.doc);
                    
                    name = items.doc.user_name
                    if (start) {
                        userName.push(name);
                    } else {

                        const cek = userName.find(data => {
                            
                            if (data == name) {return data;}
                            return false;
                        })
                        
                        if (!cek) {
                            userName.push(name);
                        }
                    }
                }

                start = false
            });

            if (!didCancel) {
                console.log("didcancel run => ")
                setDataBkkbnDocs(newDocs)
                setUserName(userName)
            }

        } catch (e) {

        }

        if (!didCancel) {
            setFetching(false);
        }
    }
    
    useEffect(() => {
        // console.log(metadata.name, 'cek metadata name')

        getAllDataBkkbn();

        return () => {
            setDidCancel(true);
        }

    }, [])

    useEffect(() => {
        
        const queryParams = qs.parse(location.search)
        let kepalas = dataBkkbnDocs.filter(kkDoc => typeof kkDoc.data_nik !== 'undefined').map(kkDoc => {
            // if(kkDoc.nama_anggotakel !== undefined) {
                let findKepala = kkDoc.data_nik.find(data_nik => data_nik.sts_hubungan);
                if (!findKepala) {
                    findKepala = kkDoc.data_nik[0]
                }
                return {
                    ...findKepala,
                    status_sensus: kkDoc.status_sensus,
                    _id: kkDoc._id
                }
        })

        setStatus(status)

        if (queryParams.query) {

            kepalas = kepalas.filter(kepala => {
                if (kepala.nama_anggotakel !== undefined) {
                    return kepala.nama_anggotakel.toLowerCase().includes(queryParams.query.toLowerCase());
                }
            })
        }

        setKepalaKels(kepalas);

    }, [dataBkkbnDocs, location.search])

    useEffect(() => {

        getSearch(name, statusSensus)

    }, [name, statusSensus])

    const getSearch = async (name, statusSensus) => {

        try {

            if (!name && !statusSensus) {

                getAllDataBkkbn();
                
            } else {

                const query = await dataBkkbn.local.allDocs({
                    include_docs: true,
                });
                //getAllDataBkkbn();
                if (name && !statusSensus) {
                    let data = []
                    query.rows.forEach(items => {
                
                        if (items.doc.user_name == name) {
                            data.push(items.doc)
                        }
                    })

                    //console.log("data search => ", data)
                    setDataBkkbnDocs(data)
                } else if (!name && statusSensus) {
                    let data = []
                    query.rows.forEach(items => {
                
                        if (items.doc.status_sensus == statusSensus) {
                            data.push(items.doc)
                        }
                    })

                    //console.log("data search => ", data)
                    setDataBkkbnDocs(data)
                } else if (name && statusSensus) {
                    let data = []
                    query.rows.forEach(items => {
                
                        if (items.doc.status_sensus == statusSensus && items.doc.user_name == name) {
                            data.push(items.doc)
                        }
                    })

                    //console.log("data search => ", data)
                    setDataBkkbnDocs(data)
                }
                //setDataBkkbnDocs(newDocs)

            }

        } catch (e) {

        }
    }

    if (isFetching) {
        return <AppPageLoading />
    }

    const handleChange = (e) => {

        if (e.target.name == "name") {
            setName(e.target.value)
        }

        if (e.target.name == "status_sensus") {
            setStatusSensus(e.target.value)
        }
    }

    return (
        <Container maxWidth="md" className={classes.container}>

            <Grid container spacing={3}>
                <Grid item xs={12} className={classes.textCenter}>
                    <Typography variant="h5" component="h1">Data Lokal</Typography>

                </Grid>
                <Grid item xs={12} md={3}>
                    <FormControl
                        variant="outlined" fullWidth>

                        <Select
                            id="name"
                            value={name || ''}
                            onChange={handleChange}
                            name="name"
                            displayEmpty
                        >
                            <MenuItem value="">User Name</MenuItem>
                            {username.map(name => <MenuItem key={name} value={name}>{name}</MenuItem>)}

                        </Select>
                    </FormControl>

                </Grid>
                <Grid item xs={12} md={3} lg={3} className={classes.textLeft}>
                    <FormControl
                        variant="outlined" fullWidth>

                        <Select
                            id="status_sensus"
                            value={statusSensus || ''}
                            name="status_sensus"
                            onChange={handleChange}
                            displayEmpty
                        >
                            <MenuItem value=""> Status </MenuItem>
                            <MenuItem value="Delete"> Delete </MenuItem>
                            <MenuItem value="Valid"> Valid </MenuItem>
                            <MenuItem value="NotValid"> NotValid </MenuItem>
                            <MenuItem value="Anomali"> Anomali </MenuItem>
                            <MenuItem value="Anomali Terkonfirmasi"> Anomali Terkonfirmasi </MenuItem>

                        </Select>

                    </FormControl>
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>
                {
                    kepalaKels.length <= 0 &&
                    <Grid item xs={12} className={classes.textCenter}>

                        <Typography>Data tidak ditemukan!</Typography>
                    </Grid>
                }
                <Grid item xs={12} >
                    <List>
                        {kepalaKels.map((kepala, index) => {
                            let no = index+1
                            return <ListItem divider key={kepala._id}>
                                {/* {
                                    statusSensus == "valid" &&
                                } */}
                                <ListItemText
                                    primary={no+'. '+kepala.nama_anggotakel}
                                    // secondary={`NIK.${kepala.nik}
                                    // Status Sensus.${kepala.status_sensus}`}
                                    secondary={
                                        <div>
                                            <div>{`NIK:${kepala.nik}`}</div>
                                            <div>{`Status: ${kepala.status_sensus}`}</div>
                                        </div>
                                    }
                                />
                                <ListItemSecondaryAction>
                                    
                                    {/* <IconButton
                                        disabled={isDeleting}
                                        component={Link} to={`form/edit/${kepala._id}`}
                                        edge="end" aria-label="edit">
                                        <EditIcon />
                                    </IconButton> */}

                                </ListItemSecondaryAction>
                            </ListItem>

                        })}
                    </List>

                </Grid>
            </Grid>
        </Container>
    )
}


export default Home;